/**
 * @description: 打开修改计划广告账号弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onAccountModify(rowIndex) {
  // 点击单行时设置check状态
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      return { ...row, accountCheck: index === rowIndex }
    })
  } else {
    if (!this.tableData.some((row) => row.accountCheck)) {
      return this.$Message.warning('请选择修改行')
    }
  }

  this.modal.showGlobalAccountModify = true
}

/**
 * @description: 更换账号确认
 * @return {*}
 */
export function onAccountModifyConfirm(account) {
  if (account) {
    this.tableData = this.tableData.map((row) => {
      if (row.accountCheck) {
        const newRow = { ...row }
        newRow.plan.account = { ...account }
        return newRow
      }

      return row
    })
  }

  this.onModifyModalCancel()
}
